import { useEffect, useState } from 'react';
import { Form, FormGroup, Label } from 'reactstrap';
import { InputField } from 'src/components';
import {
  useGetFcpsCourseListsForLogbookEntryMutation,
  useLazyGetFormByLogbookTypeAndSubjectQuery,
} from 'src/rtk/features/setup/logBookEntrySetupDetails/logBookEntrySetupDetailsApi';
import { useGetSubjectInfosQuery } from 'src/rtk/features/setup/subjectInfo/subjectInfoApi';
import AddLogbookEntryDetailsFields from './AddLogbookEntryDetailsFields';
import loader from '../../../assets/images/loader.gif';

interface QueryParams {
  id?: number;
  course_type?: string;
  subject_id?: string;
  main_training?: string;
}

export const LoadLogbookEntryDetails = (props: any) => {
  const { logbookGroup } = props;

  const [queryParams, setQueryParams] = useState<QueryParams>(
    {} as QueryParams,
  );

  const [mainTrainings, setMainTrainings] = useState<FcpsCourseList[]>([]);

  const [mainTraining, setMainTraining] = useState<FcpsCourseList>(
    {} as FcpsCourseList,
  );

  const [coreAdvance, setCoreAdvance] = useState<string>('');

  const [forms, setForms] = useState<LogbookEntrySetupMaster[]>([]);

  const [form, setForm] = useState<LogbookEntrySetupMaster>(
    {} as LogbookEntrySetupMaster,
  );

  const [logbookEntrySetupMasters, setLogbookEntrySetupMasters] = useState<LogbookEntrySetupMaster[][]>([]);
  const [logbookEntrySetupMaster, setLogbookEntrySetupMaster] = useState<LogbookEntrySetupMaster[]>([]);

  // const [systemType, setSystemType] = useState<LogbookEntrySetupMaster>(
  //   {} as LogbookEntrySetupMaster,
  // );

  // const [systemTypes, setSystemTypes] = useState<LogbookEntrySetupMaster[]>([]);

  // const [caseTypes, setCaseTypes] = useState<LogbookEntrySetupMaster[]>([]);

  // const [caseType, setCaseType] = useState<LogbookEntrySetupMaster>(
  //   {} as LogbookEntrySetupMaster,
  // );

  // const [skillTypes, setSkillTypes] = useState<LogbookEntrySetupMaster[]>([]);

  // const [skillType, setSkillType] = useState<LogbookEntrySetupMaster>(
  //   {} as LogbookEntrySetupMaster,
  // );

  const [logbookEntrySetupMasterId, setLogbookEntrySetupMasterId] =
    useState<string>('');

  const logbookEntryGroupTitleWords: string[] = logbookGroup?.title?.split(' -> ');

  const { data: getSubjectInfolist } = useGetSubjectInfosQuery();
  const subjects = getSubjectInfolist?.data;

  const [
    createFcpsCourse,
    {
      data: fcpsCourseListData,
      isSuccess: isFcpsCourseListSuccess,
      isLoading: isFcpsCourseListLoading,
      isError: isFcpsCourseListError,
      error: fcpsCourseListError,
    },
  ] = useGetFcpsCourseListsForLogbookEntryMutation();

  const [
    getForms,
    {
      data: formSetups,
      isSuccess: isFormSetupsSuccess,
      isLoading: isFormSetupsLoading,
      isFetching: isFormSetupsFetching,
      error: formSetupsError,
      isError: isFormSetupsError,
    },
  ] = useLazyGetFormByLogbookTypeAndSubjectQuery();

  const subjectOptions: SelectOption[] =
    subjects?.map((subject) => ({
      value: subject.id!,
      label: subject.subject_name,
    })) || [];

  const subject = subjects?.find(
    (subject) => subject?.id === logbookGroup?.subject_id,
  );

  useEffect(() => {
    createFcpsCourse(subject?.id!);
  }, [subject]);

  useEffect(() => {
    if (isFcpsCourseListSuccess && fcpsCourseListData?.success) {
      const mainTrainings: FcpsCourseList[] = fcpsCourseListData.data;
      setMainTrainings(mainTrainings);
    } else {
      setMainTrainings([]);
    }
  }, [isFcpsCourseListSuccess, fcpsCourseListData?.success]);

  useEffect(() => {
    const mainTraining = mainTrainings?.find(
      (mainTraining) => mainTraining.id === logbookGroup?.main_training_id,
    );

    setMainTraining(mainTraining!);
  }, [mainTrainings]);

  useEffect(() => {
    const newQueryParams: QueryParams = { ...queryParams };
    newQueryParams.subject_id = logbookGroup?.subject_id;
    newQueryParams.main_training = logbookGroup?.main_training_id;
    newQueryParams.course_type = logbookGroup?.course_type!;
    setQueryParams(newQueryParams);
    setCoreAdvance(logbookGroup?.course_type!);
  }, [mainTraining]);

  useEffect(() => {
    if (
      queryParams.subject_id &&
      queryParams.main_training &&
      queryParams.course_type
    ) {
      queryParams.id = 2;
      getForms(queryParams);
    }
  }, [queryParams]);

  useEffect(() => {
    if (formSetups && isFormSetupsSuccess) {
      setForms(formSetups?.data);
    } else {
      console.log(formSetupsError);
    }
  }, [formSetups, isFormSetupsSuccess]);

  useEffect(() => {
    let form = forms?.find(
      (form) =>
        form.id?.toLowerCase().trim() ===
        logbookGroup?.from?.toLowerCase().trim(),
    );
    // if (!form) {
    //   form = forms?.find(
    //     (form) =>
    //       form.particulars?.toLowerCase().trim() ===
    //       logbookGroup?.from?.toLowerCase().trim(),
    //   );
    // }
    const newLogbookEntrySetupMasters: LogbookEntrySetupMaster[][] = [...logbookEntrySetupMasters];
    const newLogbookEntrySetupMaster: LogbookEntrySetupMaster[] = [...logbookEntrySetupMaster];

    let childrens: LogbookEntrySetupMaster[] = form?.entry_setup_master!;
    let child: LogbookEntrySetupMaster = childrens?.find((c: LogbookEntrySetupMaster) => c.particulars === logbookEntryGroupTitleWords[4])!;
    newLogbookEntrySetupMasters[0] = childrens;
    newLogbookEntrySetupMaster[0] = child;

    let i = 5;
    while (child?.entry_setup_master?.length! > 0) {
      childrens = child?.entry_setup_master!;
      child = childrens?.find((c: LogbookEntrySetupMaster) => c.particulars === logbookEntryGroupTitleWords[i])!;
      newLogbookEntrySetupMasters.push(childrens);
      newLogbookEntrySetupMaster.push(child);
      i = i + 1;
    }

    setForm(form!);
    setLogbookEntrySetupMasters(newLogbookEntrySetupMasters);
    setLogbookEntrySetupMaster(newLogbookEntrySetupMaster);
    setLogbookEntrySetupMasterId(newLogbookEntrySetupMaster[newLogbookEntrySetupMaster.length - 1]?.id!);
  }, [forms]);

  // useEffect(() => {
  //   setSystemTypes(form?.entry_setup_master! ?? []);
  // }, [form]);

  // useEffect(() => {
  //   const systemTypeData: any = systemTypes?.find(
  //     (c: any) => c.id === logbookGroup?.case_type_id,
  //   );

  //   const systemTypeChildData: any = systemTypes?.find(
  //     (c: any) => c.id === logbookGroup?.case_type_id,
  //   )?.entry_setup_master;

  //   setSystemType(systemTypeData);

  //   if (logbookGroup?.case_type_id === '') {
  //     setLogbookEntrySetupMasterId('');
  //   } else {
  //     if (systemTypeChildData?.length === 0) {
  //       console.log('Work Done!');
  //       setLogbookEntrySetupMasterId(logbookGroup?.case_type_id || '');
  //     }
  //   }
  // }, [systemTypes]);

  // useEffect(() => {
  //   setCaseTypes(systemType?.entry_setup_master! ?? []);
  // }, [systemType]);

  // useEffect(() => {
  //   if (caseTypes?.length > 0) {
  //     const logbookGroupTitleList: string[] = logbookGroup?.title.split(' -> ');

  //     const caseTypeData: any = caseTypes?.find(
  //       (c: any) => c.particulars === logbookGroupTitleList[5],
  //     );

  //     const caseTypeChildData: any = caseTypes?.find(
  //       (c: any) => c.particulars === logbookGroupTitleList[5],
  //     )?.entry_setup_master;

  //     setCaseType(caseTypeData);

  //     if (!logbookGroupTitleList[5]) {
  //       setLogbookEntrySetupMasterId('');
  //     } else {
  //       if (caseTypeChildData?.length === 0) {
  //         setLogbookEntrySetupMasterId(caseTypeData?.id || '');
  //       }
  //     }
  //   }
  // }, [caseTypes]);

  // useEffect(() => {
  //   setSkillTypes(caseType?.entry_setup_master! ?? []);
  // }, [caseType]);

  // useEffect(() => {
  //   if (skillTypes?.length > 0) {
  //     const skillType: any = skillTypes?.find(
  //       (s: any) => s.id === logbookGroup?.skill_type_id,
  //     );
  //     setSkillType(skillType);
  //     if (logbookGroup?.skill_type_id === '') {
  //       setLogbookEntrySetupMasterId('');
  //     } else {
  //       setLogbookEntrySetupMasterId(skillType.id || '');
  //     }
  //   }
  // }, [skillTypes]);

  const mainTrainingOptions: SelectOption[] =
    mainTrainings?.map((mainTraining) => ({
      value: mainTraining.id!,
      label: mainTraining.name!,
    })) || [];

  const formOptions: SelectOption[] =
    forms?.map((e: LogbookEntrySetupMaster) => {
      return {
        label: e.particulars!,
        value: e.id!,
      };
    }) ?? [];

  // const systemTypeOptions: SelectOption[] =
  //   systemTypes?.map((e: LogbookEntrySetupMaster) => {
  //     return {
  //       label: e.particulars!,
  //       value: e.id!,
  //     };
  //   }) ?? [];

  // const caseTypeOptions: SelectOption[] =
  //   caseTypes?.map((e: LogbookEntrySetupMaster) => {
  //     return {
  //       label: e.particulars!,
  //       value: e.id!,
  //     };
  //   }) ?? [];

  // const skillTypeOptions: SelectOption[] =
  //   skillTypes?.map((e: LogbookEntrySetupMaster) => {
  //     return {
  //       label: e.particulars!,
  //       value: e.id!,
  //     };
  //   }) ?? [];

  return (
    <>
      {isFormSetupsFetching || isFcpsCourseListLoading ? (
        <div className="overlay">
          <img src={loader} alt="Loading" height={100} width={300} />
        </div>
      ) : null}
      <hr />
      <Form
        className="custom-form"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12">
            <FormGroup className="mb-3">
              <Label className="form-label">Subject</Label>
              <InputField
                type="select"
                name="subject"
                value={subject?.id}
                placeholder=""
                options={subjectOptions}
                disabled={true}
              />
            </FormGroup>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <FormGroup className="mb-3">
              <Label className="form-label">Main Training</Label>
              <InputField
                type="select"
                name="mainTraining"
                value={mainTraining?.id}
                placeholder=""
                options={mainTrainingOptions}
                disabled={true}
              />
            </FormGroup>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <FormGroup className="mb-3">
              <Label className="form-label">Core/Specialty</Label>
              <InputField
                type="select"
                name="coreAdvance"
                placeholder=""
                value={coreAdvance}
                options={[
                  { label: 'Core', value: 'core' },
                  { label: 'Specialty', value: 'adv' },
                ]}
                disabled={true}
              />
            </FormGroup>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <FormGroup className="mb-3">
              <Label className="form-label">Form</Label>
              <InputField
                type="select"
                name="form"
                placeholder=""
                value={form?.id}
                options={formOptions}
                disabled={true}
              />
            </FormGroup>
          </div>

          {/* <div className="col-lg-4 col-md-6 col-sm-12">
            <FormGroup className="mb-3">
              <Label className="form-label">System Type</Label>
              <InputField
                type="select"
                name="systemType"
                value={systemType?.id}
                placeholder=""
                options={systemTypeOptions}
                disabled={true}
              />
            </FormGroup>
          </div>

          {caseTypes?.length > 0 ? (
            <div className="col-lg-4 col-md-6 col-sm-12">
              <FormGroup className="mb-3">
                <Label className="form-label">Topic Type</Label>
                <InputField
                  type="select"
                  name="caseType"
                  value={caseType?.id}
                  placeholder=""
                  options={caseTypeOptions}
                  disabled={true}
                />
              </FormGroup>
            </div>
          ) : null}

          {skillTypes?.length > 0 ? (
            <div className="col-lg-4 col-md-6 col-sm-12">
              <FormGroup className="mb-3">
                <Label className="form-label">Skill Type</Label>
                <InputField
                  type="select"
                  name="skillType"
                  value={skillType?.id}
                  placeholder=""
                  options={skillTypeOptions}
                  disabled={true}
                />
              </FormGroup>
            </div>
          ) : null} */}

          {logbookEntrySetupMasters?.map((entrySetupMaster: LogbookEntrySetupMaster[], index: number) => {
            return (
              <div key={index} className="col-lg-4 col-md-6 col-sm-12">
                <FormGroup className="mb-3">
                  <Label className="form-label">{index === 0 ? 'System Type' : index === 1 ? 'Topic Type' : `Skill Type ${index - 1}`}</Label>
                  <InputField
                    type="select"
                    name={`skillType${index + 1}`}
                    value={logbookEntrySetupMaster[index]?.id}
                    placeholder=""
                    options={
                      entrySetupMaster?.map((e: LogbookEntrySetupMaster) => {
                        return {
                          label: e.particulars!,
                          value: e.id!,
                        };
                      }) ?? []
                    }
                    disabled={true}
                  />
                </FormGroup>
              </div>
            );
          })}
        </div>
      </Form>

      {logbookEntrySetupMasterId !== '' && logbookGroup ? (
        <AddLogbookEntryDetailsFields
          key={logbookEntrySetupMasterId}
          logbookEntrySetupMasterId={logbookEntrySetupMasterId}
          logbookGroup={logbookGroup}
          submitStatus={true}
          readOnly={false}
        />
      ) : (
        <AddLogbookEntryDetailsFields
          key={logbookEntrySetupMasterId}
          logbookEntrySetupMasterId={logbookEntrySetupMasterId}
          logbookGroup={logbookGroup}
          submitStatus={true}
          readOnly={true}
        />
      )}
    </>
  );
};
